import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";
import { IconButton } from "@mui/material";
import { de } from "date-fns/locale";
import BasicMenu from "helpers/menu";
import {
    currencyValues,
} from "../../store/helpers/common_functions";

function CichiinProjectManagement({ location, SetSelectedMenu, FetchDetails, loggedUser, wholeStructure, structures }) {
    const [open, setOpen] = useState(0);
    const [value, setValue] = useState({});
    const [list, setList] = useState([]);
    const [id, setId] = useState();
    const [departments, setDepartments] = useState([]);

    const [count, setCount] = useState(0);

    const [deleteOpen, setDeleteOpen] = useState(false);

    const history = useHistory();
    const [selected, setSelected] = React.useState(
        location.state?.status ?? "all"
    );

    const [period, setPeriod] = React.useState({
        startDate: null,
        endDate: null,
    });

    useEffect(() => {
        SetSelectedMenu({
            menu: "project",
            title: "Project Management",
        });
        fetchDepartments();
    }, []);

    const fetchDepartments = async () => {
        const response = await FetchDetails(`/api/structure/whole-structure`);
        if (response.status) {
            setDepartments(response?.data?.data[0]?.children || []);

        }
        // console.log("departments", response);
    };

    const getChildren = (parent, allStructures) => {
        const parentId = parent?.id || null;
        return allStructures.filter(s => s.parentId === parentId);
    };
    const institutionOptions = getChildren(null, wholeStructure);


    const columns = [
        {
            name: "code",
            label: "Code",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "totalActivities",
            label: "Activities",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    // <span className="text-[#000000] text-xs font-lighter">{value}</span>
                    <span className="text-custom-blue text-xs ">{value}</span>

                ),
            },
        },

        {
            name: "startDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    // <span className="text-[#A1A1A1] text-xs">
                    //     {moment(value).format("DD/MM/yyyy") ?? ""}
                    // </span>
                    <span className="text-custom-blue text-xs ">{moment(value).format("DD/MM/yyyy") ?? ""}</span>

                ),
            },
        },
        {
            name: "endDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    // <span className="text-[#A1A1A1] text-xs">
                    //     {moment(value).format("DD/MM/yyyy") ?? ""}
                    // </span>
                    <span className="text-custom-blue text-xs ">{moment(value).format("DD/MM/yyyy") ?? ""}</span>
                ),
            },
        },
        {
            name: "id",
            label: "Budget",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    const currentRow = list.find((x) => x.id === value);

                    return <span className="text-custom-blue text-xs">{
                        currentRow?.budgetType === "non-restricted" ? currentRow?.allocatedBudget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : currentRow?.budget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }</span>
                },
            },
        },
        {
            name: "budgetType",
            label: "Budget Type",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs">{value}</span>
                ),
            },
        },
        {
            name: "impact",
            label: "Impact",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs">{value}</span>
                ),
            },
        },
        {
            name: "completionPercentage",
            label: "Performance",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs">{
                        value
                            ? `${parseFloat(value).toFixed(2)}%`
                            : "0%"
                    }</span>
                ),
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    return (
                        <span style={{ fontSize: "0.85rem" }}>
                            <StatusLayout status={status == 'to-verify' ? 'under-review' : status} />
                        </span>
                    );
                },
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => (
                    <BasicMenu onDetails={() => history.push(`/admin/project/details/${v}`)} onDelete={() => {
                        setId(v); setDeleteOpen(true)
                    }} onEdit={() => {
                        setId(v);
                        setValue({
                            name: list.find((x) => x.id === v).name,
                            code: list.find((x) => x.id === v).code,
                            startDate: moment(list.find((x) => x.id === v).startDate).format("YYYY-MM-DD"),
                            endDate: moment(list.find((x) => x.id === v).endDate).format("YYYY-MM-DD"),
                            budget: list.find((x) => x.id === v).budget,
                            expenses: list.find((x) => x.id === v).expenses,
                            impact: list.find((x) => x.id === v).impact,
                            perfomance: list.find((x) => x.id === v).perfomance,
                            fundedBy: list.find((x) => x.id === v).fundedBy,
                            division: list.find((x) => x.id === v).division,
                            description: list.find((x) => x.id === v).description,
                            currency: list.find((x) => x.id === v).currency,
                            budgetType: list.find((x) => x.id === v).budgetType,
                        });
                        setOpen(2);
                    }}

                    />

                ),
            },
        },
    ];

    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue((v) => {
            v[name] = val;
            return { ...v };
        });
    };
    const onSuccess = () => setCount((v) => v + 1);
    return (
        <div className="w-full mb-12 px-4">
            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/project/delete/${id}`}
            />

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={open === 1 ? "/api/project/create" : `/api/project/update/${id}`}
                title={open === 1 ? "Create New Project" : "Edit Project"}
                fields={[
                    {
                        name: "name",
                        label: "Project Name",
                        value: value["name"],
                        required: true,
                        setValue: (val) => setValue0("name", val),
                    },
                    {
                        name: "code",
                        label: "Code",
                        value: value["code"],
                        required: true,
                        setValue: (val) => setValue0("code", val),
                    },
                    {
                        name: "startDate",
                        label: "Start Date",
                        type: "date",
                        value: value["startDate"],
                        required: true,
                        setValue: (val) => setValue0("startDate", val),
                    },
                    {
                        name: "endDate",
                        label: "End Date",
                        type: "date",
                        value: value["endDate"],
                        required: true,
                        setValue: (val) => setValue0("endDate", val),
                    },
                    {
                        name: "budgetType",
                        label: "Budget Type",
                        value: value["budgetType"],
                        type: "radio",
                        values: [
                            { label: "Restricted", value: "restricted" },
                            { label: "Non Restricted", value: "non-restricted" },

                        ],
                        required: true,
                        col: 12,
                        setValue: (val) => {
                            if (val === "non-restricted") {
                                setValue0("budget", 0);
                            } else {
                                setValue0("budget", 0);
                            }
                            setValue0("budgetType", val);

                        }

                    },
                    {
                        name: "budget",
                        label: "Budget",
                        value: value["budget"],
                        type: value["budgetType"] === "non-restricted" ? "text" : "number",
                        isNumber: true,
                        hidden: value["budgetType"] === "non-restricted",
                        disabled: value["budgetType"] === "non-restricted",
                        setValue: (val) => {
                            setValue0("budget", val);
                        },
                    },
                    {
                        name: "expenses",
                        label: "Expenditure",
                        value: value["expenses"],
                        type: "number",
                        hidden: true,
                        isNumber: true,
                        setValue: (val) => setValue0("expenses", val),
                    },
                    {
                        name: "impact",
                        label: "Impact",
                        value: value["impact"],
                        type: "select",
                        values: [
                            { label: "Low", value: "low" },
                            { label: "Medium", value: "medium" },
                            { label: "High", value: "high" },
                        ],
                        required: true,
                        setValue: (val) => setValue0("impact", val),
                    },
                    // {
                    //   name: "performance",
                    //   label: "Perfomance",
                    //   value: value["performance"],
                    //   type: "number",
                    //   setValue: (val) => setValue0("performance", val),
                    // },

                    {
                        name: "fundedBy",
                        label: "Funder",
                        value: "test",
                        hidden: true,
                        required: false,
                        type: "text",
                        setValue: (val) => setValue0("fundedBy", val),
                    },
                    //   {
                    //     name: "programId",
                    //     label: "Program",
                    //     value: program?.id,
                    //     required: false,
                    //     type: "text",
                    //     hidden: true,
                    //     setValue: (val) => setValue0("programId", val)
                    //   },

                    {
                        name: "currency",
                        label: "Currency",
                        value: value["currency"],
                        type: "select",
                        values: currencyValues,
                        required: true,
                        setValue: (val) => setValue0("currency", val),

                    },
                    {
                        name: "description",
                        label: "Project Description",
                        value: value["description"],
                        required: false,
                        type: "textarea",
                        col: 12,
                        setValue: (val) => setValue0("description", val),
                    },
                ]}
            />
            <DatatableComponent
                order={location.state?.order}
                onAddNew={() => setOpen(1)}
                processData={(data) => {
                    setList(data.data);
                    return data;
                }}
                onRowSelectionChange={(list) => {


                }
                }
                onRowClick={(data, { rowIndex }) => {
                    history.push(`/admin/project/details/${list[rowIndex].id}`);
                }}


                elevation={1}
                pdf={false}
                excel={false}
                columns={columns}
                viewColumns={false}
                searchfield={true}
                search={false}
                url={`/api/project/list?status=${selected}&count=${count}&startDate=${period.startDate}&endDate=${period.endDate}`}
                title={"All Projects List"}
            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(CichiinProjectManagement);
